import { buildingEntityHandleHash, isBuildingEntityHandle } from "building-types/entities/buildingEntityHandle";
import type { GeneratedEntityHandle } from "building-types/handles/generatedEntityHandleTypes";
import { GeneratedEntityPrefix } from "building-types/handles/generatedEntityHandleTypes";
import { assertUnreachable } from "common/utils/assertUnreachable";

export function generatedEntityHandleHash(e: GeneratedEntityHandle["entity"]) {
  if (isBuildingEntityHandle(e)) {
    return `${GeneratedEntityPrefix.BuildingEntity}.${buildingEntityHandleHash(e)}`;
  }

  if (!e?.type) {
    return "";
  }

  const handleType = e.type;

  switch (handleType) {
    case "GENERATED_PAGE_VIEW":
      return `${GeneratedEntityPrefix.GeneratedPageView}.${e.pageHash}.${e.planSetTemplateConfigId ?? ""}`;
    default:
      assertUnreachable(handleType);
  }
}
